import { AuthenticatedHttpClient } from "@/lib/axios";
import { MailboxService } from "@/services/mailbox.service";
import { ServiceContextProps } from "@/types/services.types";
import { FC, ReactNode } from "react";
import { PostmasterService } from "./postmaster.service";
import { ServiceContext } from "./ServiceProviderContext";
import { StatisticsService } from "./statistics.service";
import { TemplateService } from "./template.service";
import { UserService } from "./user.service";
import { WarmupService } from "./warmup.service";
import { OrganisationService } from "./organisation.service";
import { LabelService } from "./label.service";
import { HealthTestService } from "./healthtest.service";
import { DashboardService } from "./dashboard.service";
import { SubscriptionService } from "./subscription.service";
import { RoleService } from "./role.service";
import { InboxPlacementService } from "./inboxplacement.service";
import { SSEService } from "./sse.service";
import { ApiKeyService } from "./apikey.service";
import { B2cSenderService } from "./b2c-sender.service";
import { useSession } from "@wacht/tanstack-router";
import { MemberService } from "./member.service";

interface ServiceProviderProps {
  children: ReactNode;
}

const ServiceProvider: FC<ServiceProviderProps> = ({ children }) => {
  const { getToken } = useSession();
  const authenticatedHttpClient = new AuthenticatedHttpClient(getToken);

  const services: ServiceContextProps = {
    mailboxService: new MailboxService(authenticatedHttpClient),
    templateService: new TemplateService(authenticatedHttpClient),
    warmupService: new WarmupService(authenticatedHttpClient),
    statisticsService: new StatisticsService(authenticatedHttpClient),
    userService: new UserService(authenticatedHttpClient),
    postmasterService: new PostmasterService(authenticatedHttpClient),
    memberService: new MemberService(authenticatedHttpClient),
    organisationService: new OrganisationService(authenticatedHttpClient),
    labelService: new LabelService(authenticatedHttpClient),
    healthTestService: new HealthTestService(authenticatedHttpClient),
    dashboardService: new DashboardService(authenticatedHttpClient),
    subscriptionService: new SubscriptionService(authenticatedHttpClient),
    roleService: new RoleService(authenticatedHttpClient),
    inboxPlacementService: new InboxPlacementService(authenticatedHttpClient),
    sseService: new SSEService(authenticatedHttpClient),
    apiKeyService: new ApiKeyService(authenticatedHttpClient),
    b2cSenderService: new B2cSenderService(authenticatedHttpClient),
  };

  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};

export { ServiceProvider };
